import type { ReportLocale } from './sessionResultsLocales.ts';

/**
 * Analysis and public-report recommendations are generated in Romanian (native C++ + backend).
 * Map known strings to English for the public report when the UI locale is EN.
 */
const RO_TO_EN: Record<string, string> = {
  // posturexe-native-cpp/src/ai/mediapipe_gpu_runner.cpp
  'Corectați alinierea capului și gâtului.': 'Correct your head and neck alignment.',
  'Nivelati umerii (diferență de înălțime stânga-dreapta).':
    'Level your shoulders (left–right height difference).',
  'Verificați alinierea coloanei (înclinare laterală).':
    'Check your spinal alignment (lateral tilt).',
  'Aliniați șoldurile (diferență de înălțime).': 'Align your hips (height difference).',
  'Mențineți postura neutră.': 'Keep a neutral posture.',
  // posturexe-backend/app/api/reports.py — default when list empty
  'Continuați să mențineți o postură bună!': 'Keep maintaining good posture!',
  // posturexe-backend/app/api/reports.py — always appended specialist line
  'Luați în considerare programarea unei consultații cu un specialist în postură sau un fizioterapeut pentru a vă îmbunătăți postura și a preveni problemele pe termen lung.':
    'Consider scheduling a consultation with a posture specialist or physiotherapist to improve your posture and help prevent long-term issues.',
};

export function translateReportRecommendation(text: string, locale: ReportLocale): string {
  if (locale !== 'en') return text;
  const trimmed = text.trim();
  return RO_TO_EN[trimmed] ?? text;
}
